<template>
  <div>
    <BaseTitle :title="$t('content.attendance_title')" :yearPeriode="titleData" />
    <v-card class="mb-10">
      <div class="pa-5">
        <h3 class="app-section-title mb-5">{{ $t('content.view') }}</h3>
        <v-select v-model="mode" :items="modeList" :label="$t('view')" />
      </div>
    </v-card>

    <!-- Normal View -->
    <v-card v-show="mode === 'list'" class="mb-10">
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.attendance_title') }}</div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div v-if="permissionButton('ROLE_ATTENDANCE_CREATE') || permissionButton('ROLE_ATTENDANCE_LITE_CREATE')">
              <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" v-if="type === 'teacher'" @click="add">{{ $t('add') }}</v-btn>
              <v-btn
                color="primary"
                text
                class="btn-text-custom mb-2 mb-md-0 mr-md-2"
                v-if="type === 'teacher'"
                :loading="table.loading"
                @click="getExport"
                >{{ $t('content.export') }} <v-icon class="ml-3">mdi-download</v-icon></v-btn
              >
            </div>

            <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
            <div>
              <v-text-field v-model="searchData" :label="$t('search')" @change="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <div v-for="item in listData" :key="item.attendanceId" class="border-item">
          <v-row class="border-item">
            <v-col md="1" align="center">
              <div class="mt-5 ml-5">
                <svg-icon icon="desktop" width="30" height="30" class="primary--text" />
                <v-divider vertical></v-divider>
              </div>
            </v-col>
            <v-col md="10" class="mt-3">
              <div class="d-block">
                <h3 class="d-inline">
                  <span class="header-content">{{ item.sessionName }} </span>
                </h3>
              </div>
              <div class="d-block">
                <div>
                  <span class="body-content">
                    <span class="mr-3">
                      {{ $t('table.last_update') }}:
                      <strong>{{ item.lastUpdate }}</strong>
                    </span>
                    |
                    <span class="mr-3">
                      {{ $t('table.updated_by') }}:
                      <strong>{{ item.teacherName }}</strong>
                    </span>
                  </span>
                </div>
              </div>
              <div class="d-flex"></div>
            </v-col>
            <v-col md="1">
              <template>
                <div class="pa-5">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <span dark v-bind="attrs" v-on="on">
                        <svg-icon icon="ic-moreaction-black" class="mt-1" />
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-if="permissionButton('ROLE_ATTENDANCE_VIEW') || permissionButton('ROLE_ATTENDANCE_LITE_VIEW')">
                        <v-list-item-title class="text-dropdown" @click="viewItem(item)">{{ $t('view') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(type === 'teacher' && permissionButton('ROLE_ATTENDANCE_UPDATE')) || permissionButton('ROLE_ATTENDANCE_LITE_UPDATE')"
                      >
                        <v-list-item-title class="text-dropdown" @click="editItem(item)">{{ $t('edit') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(type === 'teacher' && permissionButton('ROLE_ATTENDANCE_DELETE')) || permissionButton('ROLE_ATTENDANCE_LITE_DELETE')"
                      >
                        <v-list-item-title class="text-dropdown-delete" @click="onDeleteItem(item)">{{ $t('table.delete') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
            </v-col>
          </v-row>
        </div>
        <NoData v-if="!listData.length" />
        <!-- <v-data-table
          :loading="table.loading"
          :server-items-length="items.length"
          :options.sync="table.options"
          :headers="tableHeader"
          :items="items"
          hide-default-footer
          class="table-custom"
        >
          <template v-slot:top>
            <table-header @fetch="getData">
              <template #left>
                <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="add">{{ $t('content.attendance_add') }}</v-btn>

                <v-btn color="primary" text class="btn-text-custom mb-2 mb-md-0 mr-md-2" @click="getExport"
                  >{{ $t('content.export') }} <v-icon class="ml-3">mdi-download</v-icon></v-btn
                >
              </template>
            </table-header>
          </template>

          <template #item.actions="{ item }">
            <v-btn text @click="onDeleteItem(item)" class="mr-1 btn-action-custom"><svg-icon icon="delete" class="red--text"/></v-btn>
            <v-btn text @click="viewItem(item)" class="mr-1 btn-action-custom"><svg-icon icon="view" class="primary--text"/></v-btn>
            <v-btn text @click="editItem(item)" class="btn-action-custom"><svg-icon icon="edit" class="primary--text"/></v-btn>
          </template>
          <template v-slot:no-data>
            <NoData />
          </template>
        </v-data-table>
        <table-footer @fetch="getData" /> -->
      </div>
    </v-card>

    <!-- Table View -->
    <div v-show="mode === 'table'" class="mb-4">
      <v-card class="pa-5 mb-10">
        <div class="d-flex align-center justify-space-between mb-5">
          <h3 class="app-section-title">{{ $t('content.student_list') }}</h3>
          <div>
            <v-text-field v-model="search" :label="$t('search')">
              <template #prepend-inner>
                <svg-icon icon="ic-search" class="primary--text mr-3" />
              </template>
            </v-text-field>
          </div>
        </div>
        <div class="attendance-scroller">
          <table class="attendance-table" v-if="attendanceData.students.length">
            <thead>
              <tr>
                <th width="250" class="attendance-sticky">
                  <div>{{ $t('form.name') }}</div>
                </th>
                <th width="280" v-for="header in temporaryHeader" :key="header.attendanceId">
                  <div>
                    <div class="d-flex flex-row justify-start align-start">
                      <div class="w-full">
                        {{ header.session ? header.session : '-' }}
                      </div>
                      <div style="width: 40%;">
                        <v-icon v-if="type === 'teacher'" color="white" @click="editSession(header)" class="mt-2 mr-2">mdi-pencil</v-icon>
                      </div>
                      <div class="w-full">({{ header.attendanceDate }} {{ header.attendanceTime }})</div>
                    </div>
                    <v-divider style="background: #fff" class="mt-3 mb-2" />
                    <div class="d-flex flex-row justify-start">
                      <div class="mr-5">
                        <small>{{ $t('table.last_update') }}</small>
                        {{ header.lastUpdate || '-' }}
                      </div>
                      <div>
                        <small>{{ $t('table.updated_by') }}</small>
                        {{ header.teacherName || '-' }}<br />
                      </div>
                    </div>
                  </div>
                </th>
                <th width="**">&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="student in studentsFilter" :key="student.studentId">
                <td class="attendance-sticky">
                  <v-row v-if="student.birthdayToday === true">
                    <v-col md="2" align="center" class="mt-3">
                      <div class="iconBirthday">
                        <svg-icon icon="ic_cake" class="primary--text" />
                      </div>
                    </v-col>
                    <v-col md="10">
                      <div class="d-block">
                        <span
                          class="d-inline"
                          style="color: #8869AD;
  font-family: Montserrat;
  font-size: 10px;
  line-height: 12px;
  text-align: left;"
                        >
                          {{ $t('content.happy_birthday') }}
                        </span>
                      </div>
                      <div class="d-block">
                        <div>
                          <span>
                            <span> {{ student.fullName }} </span>
                          </span>
                        </div>
                      </div>
                    </v-col>
                  </v-row>

                  <div class="d-flex align-center" v-else style="height:40px">{{ student.fullName }}</div>
                </td>
                <td valign="middle" v-for="att in student.attendances" :key="att.attendanceId" style="" @click="editAttendance(student, att)">
                  <span :style="{ color: colors[att.attendanceTypeId], opacity: att.newStudent ? 0.2 : 1 }">
                    {{ $t(getItemTypes(att.attendanceTypeId)) }}
                    <div v-if="att.newStudent" class="green--text" style="font-size:11px">
                      {{ $t('content.attendance_new_student') }}
                    </div>
                  </span>
                </td>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card>

      <!-- Control -->
      <div class="d-flex justify-end align-center" v-if="type === 'teacher'">
        <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="getDataTableMode">{{ $t('cancel') }}</v-btn>
        <v-btn
          v-if="permissionButton('ROLE_ATTENDANCE_CREATE') || permissionButton('ROLE_ATTENDANCE_LITE_CREATE')"
          color="primary"
          class="btn-primary-custom"
          :loading="loading"
          @click="saveTable"
          >{{ $t('submit') }}</v-btn
        >
      </div>
    </div>

    <!-- Dialog Delete -->
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
        <v-card-text>{{ $t('delete_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
          <v-btn text :loading="table.loading" @click="deleteItem">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Change Session -->
    <v-dialog v-model="dialogChangeSession" width="400" persistent>
      <v-card>
        <v-card-title class="headline secondary white--text"> Attendance</v-card-title>
        <div class="pa-6">
          <form-group :name="$t('content.session')" :validator="$v.formSession.sessionName">
            <template slot-scope="{ attrs }">
              <v-text-field
                v-model="formSession.sessionName"
                v-bind="attrs"
                :label="$t('content.session')"
                @input="$v.formSession.sessionName.$touch()"
                @blur="$v.formSession.sessionName.$touch()"
              />
            </template>
          </form-group>
          <form-group :name="$t('form.date')" :validator="$v.formSession.attendanceDate">
            <template slot-scope="{ attrs }">
              <v-menu
                ref="pickerDate"
                v-model="pickerDate"
                :close-on-content-click="false"
                :return-value.sync="pickerDate"
                min-width="290px"
                transition="scale-transition"
                offset-y
              >
                <template #activator="{ on, attrs:attrActivator }">
                  <v-text-field
                    v-model="formSession.attendanceDate"
                    v-bind="{ ...attrActivator, ...attrs }"
                    v-on="on"
                    readonly
                    :label="$t('form.date')"
                  >
                    <template #prepend-inner>
                      <svg-icon icon="calendar" class="primary--text mr-3" />
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="formSession.attendanceDate" :locale="$i18n.locale">
                  <v-spacer />
                  <v-btn text color="primary" @click="pickerDate = false">{{ $t('cancel') }}</v-btn>
                  <v-btn text color="primary" @click="$refs.pickerDate.save(formSession.attendanceDate)">{{ $t('ok') }}</v-btn>
                </v-date-picker>
              </v-menu>
            </template>
          </form-group>
          <form-group :name="$t('form.time')" :validator="$v.formSession.attendanceTime">
            <template slot-scope="{ attrs }">
              <v-menu
                ref="pickerTime"
                v-model="pickerTime"
                transition="scale-transition"
                offset-y
                min-width="290px"
                :close-on-content-click="false"
                :return-value.sync="pickerTime"
              >
                <template v-slot:activator="{ on, attrs: attrActivator }">
                  <v-text-field
                    v-model="formSession.attendanceTime"
                    v-bind="{ ...attrActivator, ...attrs }"
                    v-on="on"
                    readonly
                    :label="$t('form.time')"
                  >
                    <template #prepend-inner>
                      <svg-icon icon="clock" class="primary--text mr-3" />
                    </template>
                  </v-text-field>
                </template>
                <v-time-picker
                  v-model="formSession.attendanceTime"
                  :locale="$i18n.locale"
                  format="24hr"
                  @click:minute="$refs.pickerTime.save(formSession.attendanceTime)"
                />
              </v-menu>
            </template>
          </form-group>
        </div>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="closeDialogSession">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" class="btn-primary-custom" @click="saveSession">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Change Attendance -->
    <v-dialog v-model="dialogChangeAttendance" width="400" persistent>
      <v-card>
        <v-card-title class="headline secondary white--text"> Attendance</v-card-title>
        <div class="pa-6">
          <div v-for="item in itemTypesCondition" :key="item.value">
            <div
              class="pa-4 item-attendance d-flex"
              :style="{
                color: colors[item.value],
                'pointer-events': item.disabled ? 'none' : 'auto',
                opacity: item.disabled ? 0.3 : 1
              }"
              @click="setAttendance(item.value)"
            >
              <b style="margin-right: auto">{{ $t(item.text) }}</b>
              <v-icon v-if="dialogChangeAttendance && item.value === currentItem.attendanceTypeId">mdi-check</v-icon>
            </div>
            <v-divider />
          </div>
        </div>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="closeDialogAttendance">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" class="btn-primary-custom" @click="selectAttendance">{{ $t('select') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { groupBy, cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import { maxLength, required } from 'vuelidate/lib/validators';
import BaseTitle from '@/components/base/Title';
// import TableHeader from '@/components/table/TableHeader';
// import TableFooter from '@/components/table/TableFooter';
import NoData from '@/components/table/NoData';
import moment from 'moment-timezone';

export default {
  name: 'AttendanceIndex',
  components: {
    BaseTitle,
    // TableHeader,
    // TableFooter,
    NoData
  },
  props: {
    type: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      items: 'Attendance/items',
      itemTypes: 'Attendance/itemTypes',
      permission: 'Auth/permission',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    itemTypesCondition() {
      const copyItemTypes = cloneDeep(this.itemTypes);
      return copyItemTypes.filter(item => {
        if (this.currentItem?.status === false) {
          item.disabled = [1, 2].includes(item.value);
        } else {
          item.disabled = false;
        }
        return item;
      });
    },
    tableHeader() {
      return [
        { text: this.$t('table.session'), value: 'sessionName' },
        { text: this.$t('table.last_update'), value: 'lastUpdate' },
        { text: this.$t('table.updated_by'), value: 'teacherName' },
        { text: this.$t('table.action'), value: 'actions', width: 150, sortable: false }
      ];
    },
    modeList() {
      return [
        { text: this.$t('mode.list'), value: 'list' },
        { text: this.$t('mode.table'), value: 'table' }
      ];
    },
    studentsFilter() {
      if (!this.search) {
        return this.attendanceData.students;
      }
      return this.attendanceData.students.filter(student => student.fullName.toLowerCase().includes(this.search.toLowerCase()));
    }
  },
  validations: {
    formSession: {
      sessionName: { required, maxLength: maxLength(27) },
      attendanceDate: { required },
      attendanceTime: { required }
    }
  },
  data: () => ({
    titleData: '',
    dataClass: '',
    mode: 'list',
    attendanceData: {
      students: []
    },
    temporaryHeader: [],
    currentItem: null,
    dialogDelete: false,
    dialogChangeSession: false,
    dialogChangeAttendance: false,
    pickerDate: false,
    pickerTime: false,
    search: null,
    loading: false,
    listData: [],
    searchData: '',
    loadingLoad: false,
    table: {
      loading: false,
      options: {}
    },
    formSession: {
      attendanceId: null,
      sessionName: null,
      session: null,
      attendanceDate: null,
      attendanceTime: null,
      lastUpdate: null
    },
    colors: {
      1: '#6DD400',
      2: '#FA6400',
      3: '#F7B500',
      4: '#E02020',
      5: '#E02020'
    }
  }),
  watch: {
    'table.options': function() {
      this.getData();
    },
    mode: {
      immediate: true,
      handler(value) {
        if (value === 'list') {
          this.$store.commit('Attendance/SET_ITEM', []);
          this.$store.commit('table/RESET_PAGEABLE');
          this.getData();
        } else {
          this.getDataTableMode();
        }
      }
    }
  },
  methods: {
    permissionButton(push) {
      return this.permission.some(p => p === push) ?? false;
    },
    getExport() {
      this.table.loading = true;
      const { classId, courseId } = this.$route.params;
      this.$store
        .dispatch('Attendance/export', {
          classId,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
        })
        .then(response => {
          let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `teacher_report_attendance_${this?.dataClass?.classroomName}_${localStorage.getItem('courseName')}.xlsx`;
          link.click();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.table.loading = false));
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    getData() {
      this.loadingLoad = true;
      const { classId, courseId } = this.$route.params;
      this.$store
        .dispatch('Attendance/fetchList', {
          classId,
          courseId,
          search: this.searchData,
          ...this.table.options,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
        })
        .then(data => (this.listData = data))
        .finally(() => (this.loadingLoad = false));
    },
    add() {
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'TeacherAttendanceList' });
      } else {
        this.$router.push({ name: 'TeacherAttendanceSectionList' });
      }
    },
    editItem({ attendanceId: id }) {
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'TeacherAttendanceListEdit', params: { ...this.$route.params, id } });
      } else {
        this.$router.push({ name: 'TeacherAttendanceSectionListEdit', params: { ...this.$route.params, id } });
      }
    },
    viewItem({ attendanceId: id }) {
      if (this.type === 'teacher') {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'TeacherAttendanceListView', params: { id } });
        } else {
          this.$router.push({ name: 'TeacherAttendanceSectionListView', params: { id } });
        }
      } else {
        this.$router.push({ name: 'AdvisorAttendanceListView', params: { id } });
      }
    },
    onDeleteItem(item) {
      this.dialogDelete = true;
      this.currentItem = item;
    },
    deleteItem() {
      if (!this.currentItem) return false;
      const { classId, courseId } = this.$route.params;
      var id = this.currentItem.attendanceId;

      this.table.loading = true;
      this.$store
        .dispatch('Attendance/destroy', {
          classId,
          id,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
        })
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.currentItem = null;
          this.getData();
          this.dialogDelete = false;
        })
        .finally(() => (this.table.loading = false));
    },

    // Additonal
    getItemTypes(val) {
      return this.itemTypes.find(item => item.value === val)?.text ?? 'form.select_attendance';
    },

    // Table View
    getDataTableMode() {
      this.$store.dispatch('User/fetchProfile').then(res => {
        if (res.gmt === null) {
          res.gmt = 'Asia/Jakarta';
        }
        this.formSession.lastUpdate = moment()
          .tz(res.gmt)

          .format('YYYY-MM-DD HH:mm');
        const { classId, courseId } = this.$route.params;
        this.$store
          .dispatch('Attendance/fetchTableMode', {
            classId,
            courseId,
            ...this.table.options,
            classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
          })
          .then(data => {
            this.$set(this, 'attendanceData', data);
            this.attendanceData.students.forEach((student, i) => {
              const session = `Session ${+this.attendanceData.lastSession + 1}`;
              this.attendanceData.students[i].attendances.push({
                sessionName: `${session} (${moment().format('DD-MM-YYYY HH:mm')})`,
                session,
                attendanceDate: moment()
                  .tz(res.gmt)
                  .format('YYYY-MM-DD'),
                attendanceTime: moment()
                  .tz(res.gmt)
                  .format('HH:mm'),
                attendanceTypeId: null,
                lastUpdate: moment()
                  .tz(res.gmt)
                  .format('YYYY-MM-DD HH:mm')
              });
            });
            this.$set(this, 'temporaryHeader', this.attendanceData?.students?.[0]?.attendances);
          });
      });
    },
    saveTable() {
      // eslint-disable-next-line no-unused-vars
      const { classId, courseId } = this.$route.params;
      const payload = [];
      const flatAttendance = this.attendanceData.students.reduce((acc, row) => {
        row.attendances.forEach(item =>
          acc.push({
            studentId: row.studentId,
            ...item,
            sessionName: this.cleanSessionName(item.sessionName)
          })
        );
        return acc;
      }, []);

      // console.info();

      const groupedData = groupBy(flatAttendance, 'attendanceId');
      this.temporaryHeader.forEach(attendance => {
        payload.push({ ...attendance, sessionName: this.cleanSessionName(attendance.sessionName), students: groupedData[attendance.attendanceId] });
      });

      const lastData = payload[payload.length - 1];
      if (!lastData.students.some(s => s.attendanceTypeId)) {
        payload.splice(payload.length - 1, 1);
      }

      if (
        payload
          .reduce((acc, row) => {
            row.students.forEach(r => acc.push(r));
            return acc;
          }, [])
          .some(att => !att.newStudent && att.attendanceTypeId === null)
      ) {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('error.attendance_not_empty') });
        return;
      }
      this.loading = true;
      this.$store
        .dispatch('Attendance/updateTableMode', {
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : '',
          classId,
          courseId,
          data: payload
        })
        .then(() => {
          this.getDataTableMode();
          this.$store.dispatch('general/showSuccessNotification', { message: this.$t('content.attendance_saved') });
        })
        .finally(() => (this.loading = false));
    },

    // Session
    editSession({ attendanceId, session: sessionName, attendanceDate, attendanceTime }) {
      this.dialogChangeSession = true;
      this.formSession = { ...this.formSession, attendanceId, sessionName, attendanceDate, attendanceTime };
    },
    saveSession() {
      this.$v.formSession.$touch();
      if (this.$v.formSession.$invalid) return;

      const index = this.temporaryHeader.findIndex(header => header.attendanceId == this.formSession.attendanceId);
      if (index !== -1)
        this.temporaryHeader[index] = {
          ...this.temporaryHeader[index],
          ...this.formSession,
          session: this.formSession.sessionName,
          sessionName: `${this.formSession.sessionName} (${this.formSession.attendanceDate} ${this.formSession.attendanceTime})`
        };

      this.closeDialogSession();
    },
    closeDialogSession() {
      this.dialogChangeSession = false;
      this.clearFormSession();
    },
    clearFormSession() {
      this.formSession = { ...this.formSession, attendanceId: null, sessionName: null, attendanceDate: null, attendanceTime: null };
    },

    // Change Attendance
    editAttendance(student, { attendanceId, attendanceTypeId, newStudent }) {
      if (newStudent) return;

      this.currentItem = {
        ...this.currentItem,
        studentId: student.studentId,
        status: student.status,
        attendanceId,
        attendanceTypeId
      };
      this.dialogChangeAttendance = true;
    },
    setAttendance(val) {
      this.currentItem.attendanceTypeId = val;
    },
    selectAttendance() {
      if (!this.currentItem) return;
      const { attendanceId, attendanceTypeId, studentId } = this.currentItem;

      const sIndex = this.attendanceData.students.findIndex(s => s.studentId === studentId);
      if (sIndex === -1) return;

      const aIndex = this.attendanceData.students[sIndex].attendances.findIndex(a => a.attendanceId === attendanceId);
      if (aIndex === -1) return;

      this.attendanceData.students[sIndex].attendances[aIndex].attendanceTypeId = attendanceTypeId;
      this.closeDialogAttendance();
    },
    closeDialogAttendance() {
      this.dialogChangeAttendance = false;
      this.currentItem = null;
    },

    // Cleaner
    cleanSessionName(name) {
      return name.replace(/\(\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}\)|\(\d{2}-\d{2}-\d{4}\s\d{2}:\d{2}\)/gm, '').trim();
    }
  },
  created() {
    this.getDataClass();
  }
};
</script>

<style lang="scss" scoped>
.iconBirthday {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  background: #fff0da;
  color: #f1b65a;
  text-align: center;
  line-height: 24px;
  margin-right: 12px;

  svg {
    margin-top: 3px;
  }
}
.attendance-scroller {
  overflow-x: scroll;
  overflow-y: visible;
}

.attendance-table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th {
    padding: 10px;
    text-align: left;
    color: #fff;
  }

  td {
    padding: 0px 13px;
    height: 50px;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background: #fff;

    &:not(.attendance-sticky) {
      font-weight: bold;
      cursor: pointer;

      &:hover {
        background: #f8f8f8;
      }
    }
  }

  thead {
    tr {
      th {
        $height: 100px;
        height: $height;
        background: #00bf63;

        div {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;

          button {
            position: absolute;
            top: -5px;
            right: 0;
          }
        }
      }
    }
  }
}

.attendance-sticky {
  white-space: nowrap;
  left: 0;
  position: sticky;
  z-index: 10;

  &::before {
    content: '';
    width: 1px;
    right: 0;
    top: 0;
    bottom: 0;
    position: absolute;
    background: #ddd;
  }

  &::after {
    content: '';
    bottom: -1px;
    left: 0;
    right: 0;
    height: 1px;
    position: absolute;
    background: #ddd;
  }
}

.item-attendance {
  cursor: pointer;

  &:hover {
    background: #eee;
  }
}
.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
